var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/view/VContextMenu
 */
import $ from 'jquery';
import BaseView from './BaseView';
/**
 * @typedef {Object} MenuItem
 * @property {string} id
 * @property {string} label
 * @property {string} className
 * @property {Array.<MenuSubItem>|undefined} subMenu
 */
/**
 * @typedef {Object} MenuSubItem
 * @property {string} id
 * @property {string} label
 * @property {string} className
 */
/**
 * @enum {string}
 */
export var EventType = {};
/**
 * @classdesc
 */
var VContextMenu = /** @class */ (function (_super) {
    __extends(VContextMenu, _super);
    /**
     * @constructor
     */
    function VContextMenu() {
        var _this = this;
        var jqElement = $('<div class="v-contextmenu mdc-elevation--z4"><ul class="mdc-list collection" role="menu"/></div>');
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {Array.<MenuItem>}
         */
        _this.items_ = [];
        return _this;
    }
    /**
     * @param {MenuItem} item Item
     * @param {number=} [position] Position
     */
    VContextMenu.prototype.addOption = function (item, position) {
        if (this.indexOf_(item.id) === -1) {
            if (position) {
                this.items_.splice(position, 0, item);
            }
            else {
                this.items_.push(item);
            }
            this.render_();
        }
        else {
            console.error("Option with id \"".concat(item.id, "\" already exists")); // eslint-disable-line no-console
        }
    };
    /**
     * @param {string} id Id
     * @return {boolean} `true` If exists.
     */
    VContextMenu.prototype.exists = function (id) {
        return this.indexOf_(id) !== -1;
    };
    /**
     * @param {string} id Id
     */
    VContextMenu.prototype.removeOption = function (id) {
        var _this = this;
        var index = this.indexOf_(id);
        if (index !== -1) {
            var item = this.items_[index];
            this.removeEventListener("on-".concat(id));
            if (item.subMenu) {
                item.subMenu.forEach(function (subMenuItem) {
                    _this.removeEventListener("on-".concat(subMenuItem.id));
                });
            }
            this.items_.splice(index, 1);
            this.render_();
        }
        else {
            console.warn("Option with id \"".concat(id, "\" doesn't exist")); // eslint-disable-line no-console
        }
    };
    /**
     * Remove all options
     */
    VContextMenu.prototype.removeAllOptions = function () {
        this.items_ = [];
        this.render_();
    };
    /**
     * @param {string} id Id
     * @return {number} `true` if found.
     */
    VContextMenu.prototype.indexOf_ = function (id) {
        for (var i = 0; i < this.items_.length; i += 1) {
            if (this.items_[i].id === id) {
                return i;
            }
        }
        return -1;
    };
    /**
     * @param {string} id Id
     */
    VContextMenu.prototype.showOption = function (id) {
        this.jqElement_.find("li.".concat(id)).show();
    };
    /**
     * @param {string} id Id
     */
    VContextMenu.prototype.hideOption = function (id) {
        this.jqElement_.find("li.".concat(id)).hide();
    };
    /**
     * Toggle visibility
     */
    VContextMenu.prototype.toggle = function () {
        if (this.jqElement_.is(':visible')) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    /**
     * @private
     * @param {Event} event Event
     * @param {MenuItem|MenuSubItem} item Item from menu or submenu item.
     */
    VContextMenu.prototype.handleClickItem_ = function (event, item) {
        var eventName = "on-".concat(item.id);
        this.emit(eventName, event.target);
        this.hide();
        this.reset();
    };
    /**
     * Reset
     */
    VContextMenu.prototype.reset = function () {
        this.jqElement_.find('.vitem').removeClass('vselected');
        this.jqElement_.find('[data-submenu]').hide();
    };
    /**
     * @private
     */
    VContextMenu.prototype.render_ = function () {
        var _this = this;
        var ulElement = this.jqElement_.find('ul');
        ulElement.empty();
        this.items_.forEach(function (item) {
            ulElement.append($("<li href=\"#!\" class=\"mdc-list-item vitem collection-item ".concat(item.id).concat(item.className ? " ".concat(item.className) : '', "\" role=\"menuitem\">").concat(item.label, "</li>"))
                .click(function (e) {
                if (!item.subMenu) {
                    _this.handleClickItem_(e, item);
                }
                else {
                    _this.toggleSubmenu(item.id);
                }
            }));
            if (item.subMenu) {
                item.subMenu.forEach(function (subMenuItem) {
                    ulElement.append($("<li href=\"#!\" data-submenu=\"".concat(item.id, "\" class=\"mdc-list-item vsubmenu collection-item ").concat(subMenuItem.id).concat(subMenuItem.className ? " ".concat(subMenuItem.className) : '', "\" role=\"menuitem\">").concat(subMenuItem.label, "</li>"))
                        .click(function (e) { return _this.handleClickItem_(e, subMenuItem); }));
                });
            }
        });
    };
    /**
     * @param {string} id Id
     * @param {boolean} [visible] Visible
     */
    VContextMenu.prototype.toggleSubmenu = function (id, visible) {
        var subMenuElements = this.jqElement_.find("[data-submenu=\"".concat(id, "\"]"));
        var display;
        if (visible === undefined) {
            display = subMenuElements.is(':visible') ? 'none' : 'flex';
        }
        else if (visible === true) {
            display = 'flex';
        }
        else {
            display = 'none';
        }
        subMenuElements.css('display', display);
        var itemClicked = this.jqElement_.find(".vitem.".concat(id));
        if (subMenuElements.is(':visible')) {
            itemClicked.addClass('mdc-list-item--activated');
        }
        else {
            itemClicked.removeClass('mdc-list-item--activated');
        }
    };
    return VContextMenu;
}(BaseView));
export default VContextMenu;
//# sourceMappingURL=VContextMenu.js.map